"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveWidgetFilters = void 0;
var tslib_1 = require("tslib");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var zip_1 = tslib_1.__importDefault(require("lodash/zip"));
/**
 * Performs widget filter resolution:
 * - removes all attribute filters hit by ignoreDashboardFilters
 * - removes all date filters for date dimension different than dateDataSet
 * - picks the last date filter for the dateDataSet dimension
 *   - if it is all time, removes all date filters
 *   - otherwise returns the last date filter specified
 *
 * @param widget - widget to resolve filters for
 * @param filters - filters to try
 * @param objRefsToUris - function providing conversion of any ObjRef to URI
 * @internal
 */
function resolveWidgetFilters(filters, ignoreDashboardFilters, dateDataSet, objRefsToUris) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var dateFilters, attributeFilters, isIgnorableFilter, _a, dateFiltersToKeep, attributeFiltersToKeep, filtersToKeep;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dateFilters = filters.filter(sdk_model_1.isDateFilter);
                    attributeFilters = filters.filter(sdk_model_1.isAttributeFilter);
                    isIgnorableFilter = function (obj) {
                        return sdk_model_1.isDateFilter(obj) || sdk_model_1.isAttributeFilter(obj);
                    };
                    if (!dateFilters.length && !attributeFilters.length) {
                        return [2 /*return*/, filters];
                    }
                    return [4 /*yield*/, Promise.all([
                            getRelevantDateFiltersForWidget(dateFilters, dateDataSet, objRefsToUris),
                            getRelevantAttributeFiltersForWidget(attributeFilters, ignoreDashboardFilters, objRefsToUris),
                        ])];
                case 1:
                    _a = _b.sent(), dateFiltersToKeep = _a[0], attributeFiltersToKeep = _a[1];
                    filtersToKeep = tslib_1.__spreadArrays(dateFiltersToKeep, attributeFiltersToKeep);
                    // filter the original filter array to maintain order of the items
                    return [2 /*return*/, filters.filter(function (filter) { return !isIgnorableFilter(filter) || filtersToKeep.includes(filter); })];
            }
        });
    });
}
exports.resolveWidgetFilters = resolveWidgetFilters;
function getRelevantDateFiltersForWidget(filters, dateDataSet, objRefsToUris) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, dateDatasetUri, filterUris, withRelevantDimension, candidate;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!dateDataSet || !filters.length || filters.every(sdk_model_1.isAllTimeDateFilter)) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, objRefsToUris(tslib_1.__spreadArrays([
                            dateDataSet
                        ], filters.map(function (filter) { return sdk_model_1.filterObjRef(filter); })))];
                case 1:
                    _a = _b.sent(), dateDatasetUri = _a[0], filterUris = _a.slice(1);
                    withRelevantDimension = zip_1.default(filters, filterUris)
                        .filter(function (_a) {
                        var uri = _a[1];
                        return dateDatasetUri === uri;
                    })
                        .map(function (_a) {
                        var filter = _a[0];
                        return filter;
                    });
                    candidate = last_1.default(withRelevantDimension);
                    return [2 /*return*/, !candidate || sdk_model_1.isAllTimeDateFilter(candidate) ? [] : [candidate]];
            }
        });
    });
}
function getRelevantAttributeFiltersForWidget(filters, ignoreDashboardFilters, objRefsToUris) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var uris, divide, ignoredUris, filterUris;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ignoreDashboardFilters.length) {
                        return [2 /*return*/, filters];
                    }
                    if (!filters.length) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, objRefsToUris(tslib_1.__spreadArrays(ignoreDashboardFilters.map(sdk_backend_spi_1.dashboardFilterReferenceObjRef), filters.map(function (filter) { return sdk_model_1.filterObjRef(filter); })))];
                case 1:
                    uris = _a.sent();
                    divide = ignoreDashboardFilters.length;
                    ignoredUris = uris.slice(0, divide);
                    filterUris = uris.slice(divide);
                    return [2 /*return*/, zip_1.default(filters, filterUris)
                            .filter(function (_a) {
                            var uri = _a[1];
                            return !ignoredUris.includes(uri);
                        })
                            .map(function (_a) {
                            var filter = _a[0];
                            return filter;
                        })];
            }
        });
    });
}
//# sourceMappingURL=widgetFilters.js.map